import { render, staticRenderFns } from "./applyconfig.vue?vue&type=template&id=04b8c080&scoped=true"
import script from "./applyconfig.vue?vue&type=script&lang=js"
export * from "./applyconfig.vue?vue&type=script&lang=js"
import style0 from "./applyconfig.vue?vue&type=style&index=0&id=04b8c080&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b8c080",
  null
  
)

export default component.exports